<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <div class="page-title-section">
      <h1><mat-icon>email</mat-icon> Teste: Enviar E-mail Semanal Distribuidores</h1>
      <p class="page-subtitle">Essa página será removida</p>
    </div>
    <div class="form-section">
      <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="sendTestEmail()">
        <mat-icon>send</mat-icon><span>Enviar E-mail</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>